import React, { useState, useEffect, useCallback, useRef } from "react";
import { useTheme, useMediaQuery } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import apiRequest from "../../apiRequest";
import { endPoints } from "../../apis";
import OrderList from "./components/OrderList";
import OrderDrawer from "./components/OrderDrawer";
import StatusModal from "./components/StatusModal";
import DriverReminderModal from "./components/DriverReminderModal";
import { Backdrop, CircularProgress, Snackbar, Alert } from "@mui/material";
import { socket, connectSocket } from "../../components/socket/socket";
function OrderManagement() {
  const audioRef = useRef(null);
  const [orders, setOrders] = useState([]);
  const [orderStatuses, setOrderStatuses] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [driverReminderModalOpen, setDriverReminderModalOpen] = useState(false);
  const [statusForm, setStatusForm] = useState({ status_id: "", description: "" });
  const [driverReminderForm, setDriverReminderForm] = useState({ title: "", message: "" });
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [subCategories, setSubCategories] = useState([]);
  const [categoryId, setCategoryId] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  // socket 
  const [message, setMessage] = useState("");
  const [fetchReload, setFetchReload] = useState(false);

  useEffect(() => {
    connectSocket();

    const handleNewOrder = (data) => {
      console.log("New Order:", data);
      setMessage("New order placed!");
      setFetchReload(true);
    };

    const handleOfferReceived = (data) => {
      console.log("Offer Received:", data);
      setMessage("New offer received!");
      setFetchReload(true);
    };

    const handleOfferUpdated = (data) => {
      console.log("Offer Updated:", data);
      setMessage("Offer updated!");
      setFetchReload(true);
    };

    const handleOfferAccepted = (data) => {
      console.log("Offer Accepted:", data);
      setMessage("Offer accepted!");
      setFetchReload(true);
    };

    const handleOrderAssigned = (data) => {
      console.log("Order Assigned:", data);
      setMessage("Order assigned!");
      setFetchReload(true);
    };

    const handleOrderCancelled = (data) => {
      console.log("Order Cancelled:", data);
      setMessage("Order cancelled!");
      setFetchReload(true);
    };
    socket.on("newOrder", handleNewOrder);
    socket.on("offerReceived", handleOfferReceived);
    socket.on("offerUpdated", handleOfferUpdated);
    socket.on("offerAccepted", handleOfferAccepted);
    socket.on("orderAssigned", handleOrderAssigned);
    socket.on("orderCancelled", handleOrderCancelled);

    return () => {
      socket.off("newOrder", handleNewOrder);
      socket.off("offerReceived", handleOfferReceived);
      socket.off("offerUpdated", handleOfferUpdated);
      socket.off("offerAccepted", handleOfferAccepted);
      socket.off("orderAssigned", handleOrderAssigned);
      socket.off("orderCancelled", handleOrderCancelled);
    };
  }, []);

  const playSound = () => {
    if (!audioRef.current) {
      audioRef.current = new Audio("/sounds/bill.wav");
      audioRef.current.preload = "auto";
    }
    const audio = audioRef.current;
    audio.currentTime = 0;
    audio.play().catch((err) => {
      console.warn("Audio play blocked until user interaction:", err);
    });
  };
  
  useEffect(() => {
    if (audioRef.current) return;
    audioRef.current = new Audio("/sounds/bill.wav");
    audioRef.current.preload = "auto";

    const unlockAudio = () => {
      const audio = audioRef.current;
      if (!audio) return;
      audio.muted = true;
      audio
        .play()
        .then(() => {
          audio.pause();
          audio.currentTime = 0;
          audio.muted = false;
        })
        .catch(() => {});
      window.removeEventListener("click", unlockAudio);
      window.removeEventListener("keydown", unlockAudio);
      window.removeEventListener("touchstart", unlockAudio);
    };

    window.addEventListener("click", unlockAudio, { once: true });
    window.addEventListener("keydown", unlockAudio, { once: true });
    window.addEventListener("touchstart", unlockAudio, { once: true });
  }, []);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const getSubCategories = useCallback(async (parentId = null) => {
    try {
      const params = { limit: 0 };
      if (parentId) params.parent_id = parentId;
      const headers = {};
      const response = await apiRequest.get(endPoints.GET_SUB_CATEGORIES, params, headers);
      if (response.success) {
        setSubCategories(response.data.items || []);
      }
    } catch (error) {
      console.error("Error fetching sub categories:", error);
      setError("Failed to fetch sub categories. Please try again.");
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchSingleOrder = async (id) => {
    try {
      const response = await apiRequest.get(`${endPoints.GET_SINGLE_ORDER}/${id}`, {}, {});
      if (response.success) {
        setSelectedOrder(response.data);
      }
    } catch (error) {
      console.error("Error fetching order statuses:", error);
    }
  };

  const fetchOrders = useCallback(async (page, selectedStatus, searchValue, categoryId, selectedYear, selectedMonth) => {
    // playSound();
    // setLoading(true);
    try {
      const params = { page, total: totalItems, status: selectedStatus, search: searchValue, year: selectedYear, month: selectedMonth };
      if (categoryId) params.category_id = categoryId;
      const response = await apiRequest.get(endPoints.GET_ORDERS, params, {});
      if (response.success) {
        const { orders, order_statuses } = response.data;
        setOrders(orders?.items);
        setOrderStatuses(order_statuses);
        setTotalPages(orders?.pagination?.total_pages);
        setCurrentPage(orders?.pagination?.current_page);
        setTotalItems(orders?.pagination?.totalItems);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
      setError("Failed to fetch orders. Please try again.");
    }
    // finally {
    //   setLoading(false);
    // }
  }, [totalItems]);

  useEffect(() => {
    getSubCategories();
    fetchOrders(currentPage, selectedStatus, searchValue, categoryId, selectedYear, selectedMonth);
  }, [currentPage, selectedStatus, searchValue, selectedYear, selectedMonth, fetchOrders, categoryId, getSubCategories]);

  useEffect(() => {
    if (!fetchReload) return;
    playSound();
    fetchOrders(currentPage, selectedStatus, searchValue, categoryId, selectedYear, selectedMonth);
    setFetchReload(false);
  }, [fetchReload, fetchOrders, currentPage, selectedStatus, searchValue, categoryId, selectedYear, selectedMonth]);

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleDetailClick = (order) => {
    fetchSingleOrder(order.id);
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
    setSelectedOrder(null);
  };

  const handleStatus = (id) => {
    setSelectedStatus(id);
  };

  const handleStatusChange = (e) => {
    const { name, value } = e.target;
    setStatusForm(prev => ({ ...prev, [name]: value }));
  };

  const handleDriverReminderChange = (e) => {
    const { name, value } = e.target;
    setDriverReminderForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSaveStatus = async () => {
    if (!statusForm.status_id) {
      setError("Please select a status.");
      return;
    }
    const formData = {
      status_id: statusForm.status_id,
      order_id: selectedOrder?.id,
      description: statusForm.description
    };
    const response = await apiRequest.post(endPoints.CHANGE_ORDER_STATUS, formData, {});
    if (response.success) {
      fetchOrders(currentPage, selectedStatus);
      fetchSingleOrder(selectedOrder?.id);
      setStatusModalOpen(false);
      setSuccess("Order status updated successfully.");
    } else {
      setError("Failed to update order status. Please try again.");
    }
  };

  const handleSendDriverReminder = async () => {
    if (!driverReminderForm.title || !driverReminderForm.message) {
      setError("Title and message are required.");
      return;
    }
    const formData = {
      order_id: selectedOrder?.id,
      title: driverReminderForm.title,
      description: driverReminderForm.message
    };

    const response = await apiRequest.post(endPoints.SEND_DRIVER_REMINDER, formData, {});
    console.log(response)
    if (!response.success) {
      setError("Failed to send driver reminder. Please try again.");
      return;
    }
    setDriverReminderModalOpen(false);
    setSuccess("Driver reminder sent successfully.");
  };

  const handleDriverReminderModal = () => {
    setDriverReminderModalOpen(true);
    setDriverReminderForm({ title: "", message: "" });
  };

  const handleStatusModal = () => {
    setStatusModalOpen(true);
    setStatusForm({ title: "", message: "" });
  };

  // console.log(selectedYear, selectedMonth );
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <OrderList
        orders={orders}
        orderStatuses={orderStatuses}
        currentPage={currentPage}
        totalPages={totalPages}
        selectedStatus={selectedStatus}
        searchValue={searchValue}
        subCategories={subCategories}
        categoryId={categoryId}
        isMobile={isMobile}
        handlePageChange={handlePageChange}
        handleDetailClick={handleDetailClick}
        handleStatus={handleStatus}
        setSearchValue={setSearchValue}
        setCategoryId={setCategoryId}
        selectedY={setSelectedYear}
        selectedM={setSelectedMonth}

      />
      <Footer />

      <Backdrop open={loading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Snackbar
        open={!!error || !!success || !!message}
        autoHideDuration={3000}
        onClose={() => { setError(null); setSuccess(null); setMessage(null); }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={() => { setError(null); setSuccess(null); setMessage(null); }}
          severity={error ? "error" : "success"}
          sx={{ width: '100%' }}
        >
          {error || success || message}
        </Alert>
      </Snackbar>

      <OrderDrawer
        isDrawerOpen={isDrawerOpen}
        isMobile={isMobile}
        selectedOrder={selectedOrder}
        handleCloseDrawer={handleCloseDrawer}
        handleStatusModal={handleStatusModal}
        handleDriverReminderModal={handleDriverReminderModal}
      />

      <StatusModal
        statusModalOpen={statusModalOpen}
        statusForm={statusForm}
        orderStatuses={orderStatuses}
        handleStatusChange={handleStatusChange}
        handleSaveStatus={handleSaveStatus}
        setStatusModalOpen={setStatusModalOpen}
      />

      <DriverReminderModal
        driverReminderModalOpen={driverReminderModalOpen}
        driverReminderForm={driverReminderForm}
        handleDriverReminderChange={handleDriverReminderChange}
        handleSendDriverReminder={handleSendDriverReminder}
        setDriverReminderModalOpen={setDriverReminderModalOpen}
      />
    </DashboardLayout>
  );
}

export default OrderManagement;
